// removed by extract-text-webpack-plugin
module.exports = {"icon":"onfido-sdk-ui-crossDevice-MobileNotificationSent-icon","submessage":"onfido-sdk-ui-crossDevice-MobileNotificationSent-submessage","boldMessage":"onfido-sdk-ui-crossDevice-MobileNotificationSent-boldMessage","cancel":"onfido-sdk-ui-crossDevice-MobileNotificationSent-cancel","help":"onfido-sdk-ui-crossDevice-MobileNotificationSent-help","helpList":"onfido-sdk-ui-crossDevice-MobileNotificationSent-helpList"};


//////////////////
// WEBPACK FOOTER
// ./components/crossDevice/MobileNotificationSent/style.css
// module id = 395
// module chunks = 1